import React, { useState, useEffect, createContext } from 'react';

export default function ThemeProvider({ children }) {
	const ThemeContext = createContext();
	const [theme, setTheme] = useState('light');

      useEffect(() => {
        const tg = window.Telegram?.WebApp;

        if (tg) {
          const colorScheme = tg.colorScheme;
          setTheme(colorScheme || 'light');
        }
      }, [theme]);

      useEffect(() => {
        const root = window.document.documentElement;

        if (theme === 'dark') {
          root.classList.add('dark');
        } else {
          root.classList.remove('dark');
        }
      }, [theme]);

      const toggleTheme = () => {
        setTheme(prevTheme => prevTheme === 'light' ? 'dark' : 'light');
      };

      return (
        <ThemeContext.Provider value={{ theme, toggleTheme }}>
          {children}
        </ThemeContext.Provider>
      );
}